import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { ENTER, SPACE } from '@angular/cdk/keycodes';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

import { SearchService } from '@journal/core/api/search/search.service';
import { environment } from '@journal/env/environment';
import { FilterSortDialogComponent } from '../filter-sort-dialog/filter-sort-dialog.component';

import { MetaDefinition } from '@angular/platform-browser';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import _ from 'lodash';

export interface Type {
  name?: string;
  type?: string;
  title?: string;
}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  querySubscription: any;
  searchString: string;
  searchTabs = [];
  @ViewChild('tabsContent') tabsContent: ElementRef;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isLoading = false;
  showSpinner = false;
  next = null;
  page = 1;
  searchResults = 0;
  totalCount = 0;
  startDate: string = '';
  endDate: string = '';
  searchQuery: any = [];
  disciplines = [];
  journalTypes = [];
  tags = [];
  filteredResults = [];
  selectedDisciplines: any = [];
  isLoadingDisciplines: boolean = false;
  disciplineArray: any = [];
  selectedJournalTypes: any = [];
  isLoadingJournalTypes: boolean = false;
  journalTypeArray: any = [];
  selectedOrder: string = '-created_at';
  chosenTab: string = 'Journal';

  isAll: boolean = true;
  isPrevious: boolean = false;
  isUpcoming: boolean = false;
  urlSubstring: string = '';
  editorial: boolean = false;

  order: Type[] = [
    { name: 'Alphabetical order: A-Z', type: 'content__title', title: 'A-Z' },
    { name: 'Alphabetical order: Z-A', type: '-content__title', title: 'Z-A' },
    { name: 'Latest First', type: '-created_at', title: 'Latest' },
    { name: 'Oldest First', type: 'created_at', title: 'Oldest' },
    { name: 'Popularity', type: '-likes_count', title: 'Popularity' },
  ];
  readonly separatorKeysCodes: number[] = [ENTER, SPACE];

  public disciplineControl: FormControl = new FormControl();
  public disciplineSearchControl: FormControl = new FormControl();
  public searchedDisciplines: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public journalTypeControl: FormControl = new FormControl();
  public journalTypeSearchControl: FormControl = new FormControl();
  public searchedJournalTypes: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public userFilterValue: FormControl = new FormControl('');
  public referenceFilterValue: FormControl = new FormControl('');
  public journal: FormControl = new FormControl('');
  searchJournalControl: FormControl = new FormControl();

  // public tagControl: FormControl = new FormControl();
  // public searchTagControl: FormControl = new FormControl();
  // public searchedTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @ViewChild('input') private elementRef: ElementRef;
  @ViewChild('chipSection') chipList: ElementRef;

  private _onDestroy = new Subject<void>();
  dateRange: string = '';
  selectedRange: string = '';
  orderTitle: string = null;
  showScroll: boolean = false;

  constructor(
    public searchService: SearchService,
    public metaService: MetaService,
    public route: ActivatedRoute,
    public router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.initializeFiltersFromParams();
    this.searchTabs = this.userService.getSearchTabs();
    this.initJournalSearchControl();
    this.updateMetaInfo();
    this.setParams();
    this.getDisciplines();
    this.getJournalTypes();
    this.checkSearchDisciplineParam();
    this.filterBlogs();
  }

  @HostListener('window:scroll', ['$event'])
  @HostListener('window:resize', ['$event'])
  onWindowScroll(): void {
    const currentPos = (document.documentElement.scrollTop || document.body.scrollTop);
    const maxPos = document.documentElement.scrollHeight;
    if (currentPos >= maxPos / 2 && (this.next) && !this.showSpinner) {
      this.showSpinner = true;
      if (this.next) {
        this.filterBlogs(true);
      }
    }
    this.showScroll = Boolean(this.tabsContent.nativeElement.offsetWidth < this.chipList.nativeElement.offsetWidth && window.innerWidth > 960);
    this.tabsContent.nativeElement.style.overflow = window.innerWidth <= 960 ? 'scroll' : 'hidden';
  }
  initializeFiltersFromParams() {
    this.querySubscription = this.route.queryParams.subscribe(
      (params) => {
        this.searchString = params.query;
        params.order ? this.selectedOrder = params.order : this.selectedOrder = this.order[2].type;
        if (params.order) {
          this.order.filter(ord=> {
            if (params.order == ord.type) {
              this.orderTitle = ord.title;
            }
          })
        } else {
          this.orderTitle = this.order[0].title;
        }
        if (params.types) {
          let tempJournalTypeArray = params.types.split(',');
          for (let journalType of tempJournalTypeArray) {
            journalType = parseInt(journalType, 10);
            if (journalType) {
              if (!this.journalTypeArray.includes(journalType)) {
                this.journalTypeArray.push(journalType);
              }
            }
          }
        }
        if (params.disciplines) {
          let tempDisciplineArray = params.disciplines.split(',');
          for (let discipline of tempDisciplineArray) {
            discipline = parseInt(discipline, 10);
            if (params.disciplines) {
              if (!this.disciplineArray.includes(discipline)) {
                this.disciplineArray.push(discipline);
              }
            }
          }
        }
        if (this.searchString) {
          const tempArray = this.searchString.split(',');
          for (const item of tempArray) {
            if (!this.searchQuery.includes(item)) {
              this.searchQuery.push(item);
            }
          }
        }
        if (params.user) {
          this.userFilterValue.setValue(params.user);
        }
        if (params.reference) {
          this.referenceFilterValue.setValue(params.reference);
        }
        if (params.date_range) {
          let tempDateRange = params.date_range.split(',');
          this.startDate = tempDateRange[0];
          this.endDate = tempDateRange[1];
          if (!this.selectedRange) {
            this.selectedRange = 'Custom';
          } this.dateRange = `${this.startDate},${this.endDate}`;
        }
        if (params.editorial == "true"){
          this.editorial = true;
        }
      });
  }

  initJournalSearchControl(): void {
    this.searchJournalControl.valueChanges
      .pipe(
        switchMap(
          (value: any) => (
            this.searchService.getFilteredBlogs(this.page, this.searchQuery.toString(),
              this.disciplineArray.toString(),
              this.journalTypeArray.toString(), this.selectedOrder, this.dateRange,
              this.userFilterValue.value, this.referenceFilterValue.value, this.editorial
            ))
        )
      ).subscribe(
        (response: any) => {
          this.totalCount = response.count;
          this.searchResults += response.results.length;
          this.filteredResults = [...this.filteredResults, ...response.results];
          if (response.next) {
            this.next = response.next;
            const num = this.next.match(/page=(\d+)/)[1];
            this.page = parseInt(num);
          } else {
            this.next = null;
          }
          this.isLoading = false;
          this.showSpinner = false;
        }, (err) => {
          console.log(err);
        });
  }

  setEditorial(event){
    this.editorial = event.checked;
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  scroll(direction: string): void {
    if (direction === 'left') {
      this.tabsContent.nativeElement.scrollLeft -= 150;
    }
    else {
      this.tabsContent.nativeElement.scrollLeft += 150;
    }
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    if (this.elementRef.nativeElement) {
      this.elementRef.nativeElement.focus();
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkSearchDisciplineParam(): void {
    const discipline = this.searchService.getSearchDiscipline();
    if (discipline) {
      this.setDiscipline(discipline);
    }
  }

  updateMetaInfo(): void {
    const metaInfo: MetaDefinition[] = [
      { name: 'title', content: 'Architecture & Design journals' },
      { name: 'description',
        content: 'The architecture and design blog platform for architects, interior designers and design enthusiast.' }
    ];
    metaInfo.forEach(meta => {
      this.metaService.updateMetaInfo(meta);
    });
    this.metaService.updateMeta(metaInfo);
    this.metaService.updateTitle('Architecture & Design journals');
    this.metaService.createCanonicalURL();
  }

  getDisciplines(): void {
    this.isLoadingDisciplines = true;
    this.searchService.getDisciplines().subscribe(
      (response: any) => {
        this.disciplines = _.orderBy(response, 'name', 'asc');
        this.searchedDisciplines.next(this.disciplines.slice());
        this.isLoadingDisciplines = false;
        for (const discipline of this.disciplineArray) {
          let disciplineObj = this.disciplines.find(obj => obj.id == discipline);
          if (disciplineObj) {
            console.log(this.selectedDisciplines.find(obj => obj.id == disciplineObj.id));
            if (!this.selectedDisciplines.find(obj => obj.id == disciplineObj.id)) {
              this.selectedDisciplines.push(disciplineObj);
              this.disciplineControl.setValue(this.selectedDisciplines);
            }
          }
          else {
            let index = this.disciplineArray.indexOf(discipline);
            this.disciplineArray.splice(index, 1);
          }
        }
        console.log(this.selectedDisciplines);
        this.disciplineSearchControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterDisciplines();
          });
      }, (err) => {
        console.log(err);
      });
  }

  getJournalTypes(): void {
    this.isLoadingJournalTypes = true;
    this.searchService.getBlogTypes().subscribe(
      (response: any) => {
        this.journalTypes = _.orderBy(response.results, 'name', 'asc');
        this.searchedJournalTypes.next(this.journalTypes.slice());
        for (const journalType of this.journalTypeArray) {
          let journalTypeObj = this.journalTypes.find(obj => obj.id == journalType);
          if (journalTypeObj) {
            if (!this.selectedJournalTypes.some(obj =>  obj.id == journalTypeObj.id )) {
              this.selectedJournalTypes.push(journalTypeObj);
            }
            this.journalTypeControl.setValue(this.selectedJournalTypes);
          }
          else {
            let index = this.journalTypeArray.indexOf(journalType);
            this.journalTypeArray.splice(index, 1);
          }
        }
        this.isLoadingJournalTypes = false;
        this.journalTypeSearchControl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterJournalTypes();
          });
      }, (err) => {
        console.log(err);
      });
  }

  filterDisciplines(): void {
    if (!this.disciplines) {
      return;
    }
    let search = this.disciplineSearchControl.value;
    if (!search) {
      this.searchedDisciplines.next(this.disciplines.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedDisciplines.next(
      this.disciplines.filter(discipline => discipline.name.toLowerCase().indexOf(search) > -1)
    );
  }

  filterJournalTypes(): void {
    if (!this.journalTypes) {
      return;
    }
    let search = this.journalTypeSearchControl.value;
    if (!search) {
      this.searchedJournalTypes.next(this.journalTypes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedJournalTypes.next(
      this.journalTypes.filter(journalType => journalType.name.toLowerCase().indexOf(search) > -1)
    );
  }


  addSearchText(text): void {
    const value = text;

    if ((value || '').trim()) {
      this.searchQuery.push(value.trim().toLowerCase());
      this.resetPage();
      this.setParams();
      this.filterBlogs();
    }
  }

  removeSearchText(result: any): void {
    const index = this.searchQuery.indexOf(result);
    if (index >= 0) {
      this.searchQuery.splice(index, 1);
    }
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  setDiscipline(disciplineObj): void {
    if (!this.disciplineArray.includes(disciplineObj.id)) {
      this.selectedDisciplines.push(disciplineObj);
      this.disciplineArray.push(disciplineObj.id);
    }
    this.disciplineControl.setValue(this.selectedDisciplines);
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  removeDiscipline(disciplineObj) {
    this.selectedDisciplines = this.selectedDisciplines.filter((item, value) => {
      return item.id !== disciplineObj.id;
    });
    const index = this.disciplineArray.indexOf(disciplineObj.id);
    if (index >= 0) {
      this.disciplineArray.splice(index, 1);
    }
    if (this.selectedDisciplines.length > 0) {
      this.disciplineControl.setValue(this.selectedDisciplines);
    } else {
      this.disciplineControl.setValue(null);
    }
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  removeJournalType(journalType) {
    this.selectedJournalTypes = this.selectedJournalTypes.filter((item, value) => {
      return item.id !== journalType.id;
    });
    const index = this.journalTypeArray.indexOf(journalType.id);
    if (index >= 0) {
      this.journalTypeArray.splice(index, 1);
    }
    if (this.selectedJournalTypes.length > 0) {
      this.journalTypeControl.setValue(this.selectedJournalTypes);
    } else {
      this.journalTypeControl.setValue(null);
    }
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  removeDateRange(): void {
    this.dateRange = '';
    this.selectedRange = '';
    this.startDate = '';
    this.endDate = '';
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }


  setJournalType(journalTypeObj: any): void {
    if (!this.journalTypeArray.includes(journalTypeObj.id)) {
      this.selectedJournalTypes.push(journalTypeObj);
      this.journalTypeArray.push(journalTypeObj.id);
    }
    this.journalTypeControl.setValue(this.selectedJournalTypes);
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  setOrderType(orderObj: any): void {
    this.selectedOrder = orderObj.type;
    this.orderTitle = orderObj.title;
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  setReference(): void {
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  reset(type: string): void {
    if (type === 'order') {
      this.selectedOrder = this.order[0].type;
      this.orderTitle = this.order[0].title;
    } else {
      this.selectedDisciplines = [];
      this.disciplineArray = [];
      this.selectedOrder = this.order[0].type;
      this.orderTitle = this.order[0].title;
      this.disciplineControl.setValue(null);
      this.selectedJournalTypes = [];
      this.journalTypeArray = [];
      this.journalTypeControl.setValue(null);
      this.dateRange = '';
      this.selectedRange = '';
      this.startDate = '';
      this.endDate = '';
      this.userFilterValue.reset('');
      this.referenceFilterValue.reset('');
    }
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  filterBlogs(isLoadMore?: boolean): void {
    if (isLoadMore) {
      console.log('Load more');
    }
    else {
      this.searchResults = 0;
    }
    if (!this.showSpinner) {
      this.isLoading = true;
    }
    if (this.isPrevious) {
      this.urlSubstring = 'inactive';
    } else if (this.isUpcoming) {
      this.urlSubstring = 'upcoming';
    } else if (!(this.isUpcoming || this.isPrevious || this.isAll)) {
      this.urlSubstring = 'active';
    }
    this.searchJournalControl.reset();
  }

  loadMore(): void {
    this.showSpinner = true;
    if (this.next != null) {
      this.page = this.next.match(/page=(\d+)/)[1];
      this.filterBlogs(true);
    }
  }

  resetPage(): void {
    this.page = 1;
    this.filteredResults = [];
  }

  setParams(): void {
    this.router.navigate([], {
      queryParams: {
        query: this.searchQuery.toString(),
        order: this.selectedOrder,
        types: this.journalTypeArray.toString(),
        disciplines: this.disciplineArray.toString(),
        user: this.userFilterValue.value,
        reference: this.referenceFilterValue.value,
        date_range: this.dateRange,
        editorial: this.editorial,
      },
      queryParamsHandling: 'merge',
    });
    // }
  }

  getSearchUrl(appUrl: string) {
    const query = this.searchQuery.toString();
    if (this.searchQuery.length > 0) {
      return `${environment[appUrl]}search?query=${query}`;
    } else {
      return `${environment[appUrl]}search`;
    }
  }
  openFilterDialog() {
    this.openFilterSortDialog(true);
  }

  openSortDialog() {
    this.openFilterSortDialog(false, true);
  }


  openFilterSortDialog(filter: boolean = false, sort: boolean = false): void {
    const dialogRef = this.dialog.open(FilterSortDialogComponent, {
      maxHeight: '80vh',
      maxWidth: '100vw',
      width: '100vw',
      panelClass: 'custom-search-dialogbox',
      data: {
        filter: filter,
        sort: sort,
        order: this.order,
        disciplines: this.disciplines,
        selectedDisciplines: this.selectedDisciplines,
        disciplineArray: this.disciplineArray,
        journalTypes: this.journalTypes,
        selectedJournalTypes: this.selectedJournalTypes,
        journalTypeArray: this.journalTypeArray,
        selectedOrder: this.selectedOrder,
        dateRange: this.dateRange,
        selectedRange: this.selectedRange,
        startDate: this.startDate,
        endDate: this.endDate,
        userFilterValue: this.userFilterValue.value,
        referenceFilterValue: this.referenceFilterValue.value,
        editorial: this.editorial
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.disciplineArray = result.disciplineArray;
        this.selectedDisciplines = result.selectedDisciplines;
        this.journalTypeArray = result.journalTypeArray;
        this.selectedJournalTypes = result.selectedJournalTypes;
        this.selectedOrder = result.selected_order;
        this.dateRange = result.dateRange;
        this.selectedRange = result.selectedRange;
        this.startDate = result.startDate;
        this.endDate = result.endDate;
        this.userFilterValue.setValue(result.userFilterValue);
        this.referenceFilterValue.setValue(result.referenceFilterValue);
        this.editorial = result.editorial;
        this.resetPage();
        this.filterBlogs();
      }
    });
  }

  setDateRange(range: any): void {
    this.dateRange = range.startDate + ',' + range.endDate;
    this.selectedRange = range.selectedRange;
    this.startDate = range.startDate;
    this.endDate = range.endDate;
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  setUser(): void {
    this.resetPage();
    this.setParams();
    this.filterBlogs();
  }

  tabSelected(tab): void {
    this.chosenTab = tab.name;
    // This is added just for the scenario when the user changes screen size.
  }

}
